import React from 'react';
import { Link } from 'react-router-dom';
import { X } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface MobileMenuProps {
  isOpen: boolean;
  onClose: () => void;
}

export function MobileMenu({ isOpen, onClose }: MobileMenuProps) {
  const { t } = useTranslation();

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 lg:hidden">
      <div className="fixed inset-0 bg-black/50" onClick={onClose} />
      
      <div className="fixed right-0 top-0 bottom-0 w-64 bg-white p-6 shadow-xl">
        <div className="flex justify-end mb-8">
          <button onClick={onClose} className="p-2">
            <X className="w-6 h-6" />
          </button>
        </div>

        <nav className="space-y-4">
          <Link
            to="/"
            onClick={onClose}
            className="block py-2 text-gray-700 hover:text-blue-600"
          >
            {t('nav.home')}
          </Link>

          <Link
            to="/web-hosting"
            onClick={onClose}
            className="block py-2 text-gray-700 hover:text-blue-600"
          >
            {t('nav.webHosting')}
          </Link>

          <Link
            to="/game-hosting"
            onClick={onClose}
            className="block py-2 text-gray-700 hover:text-blue-600"
          >
            {t('nav.gameHosting')}
          </Link>

          <Link
            to="/vps"
            onClick={onClose}
            className="block py-2 text-gray-700 hover:text-blue-600"
          >
            {t('nav.vps')}
          </Link>

          <Link
            to="/dedicated"
            onClick={onClose}
            className="block py-2 text-gray-700 hover:text-blue-600"
          >
            {t('nav.dedicated')}
          </Link>

          <div className="py-2">
            <p className="text-sm font-semibold text-gray-400 mb-2">
              {t('nav.businessSolutions')}
            </p>
            <div className="pl-4 space-y-2">
              <Link
                to="/colocation"
                onClick={onClose}
                className="block py-2 text-gray-700 hover:text-blue-600"
              >
                {t('nav.colocation')}
              </Link>
              <Link
                to="/ip-transit"
                onClick={onClose}
                className="block py-2 text-gray-700 hover:text-blue-600"
              >
                {t('nav.ipTransit')}
              </Link>
            </div>
          </div>

          <Link
            to="/contact"
            onClick={onClose}
            className="block py-2 text-gray-700 hover:text-blue-600"
          >
            {t('nav.contact')}
          </Link>

          <div className="pt-4">
            <a
              href="https://my.synthohosting.net/login.php"
              target="_blank"
              rel="noopener noreferrer"
              className="block w-full py-2 px-4 bg-blue-600 text-white rounded-md text-center hover:bg-blue-700"
            >
              {t('nav.clientArea')}
            </a>
          </div>
        </nav>
      </div>
    </div>
  );
}